import React, { useEffect, useRef, useState } from 'react';
import './threeLevels.css';
import { FaPhone, FaCar } from "react-icons/fa";
import { IoMail } from "react-icons/io5";



export default function LoanSteps() {
    const steps = [
        {
            icon: <IoMail size={30} color={'var(--dark-blue)'} />,
            title: 'מזמינים באתר',
            description: 'ממלאים את טופס ההשלמה כאן באתר עם כל הפרטים הרלוונטיים',
        },
        {
            icon: <FaPhone size={30} color={'var(--dark-blue)'} />,
            title: 'ממתינים לטלפון',
            description: 'יש לחכות לטלפון שהכלים נשמרו לכם לתאריך שבחרתם (זה יכול לקחת כמה ימים)',
        },
        {
            icon: <FaCar size={30} color={'var(--dark-blue)'} />,
            title: 'באים לקחת',
            description: 'מגיעים ביום של האירוע בשעות בוקר - צהריים לקחת את הכלים עם רכב או עם עגלה גדולה',
        },
    ];

    const containerRef = useRef();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.2 }
        );

        if (containerRef.current) observer.observe(containerRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="loan-steps-container" ref={containerRef}>
            {steps.map((step, index) => (
                <div
                    className={`step ${visible ? 'visible' : ''}`}
                    style={{ transitionDelay: `${index * 0.3}s` }}
                    key={index}
                >
                    <div className='circle-icon'>
                        {step.icon}
                    </div>
                    <h4 className="step-title gold-text-gradient">{step.title}</h4>
                    <p className="step-description">{step.description}</p>
                    {index < steps.length - 1 && <div className="arrow gold-text-gradient">←</div>}
                </div>
            ))}
        </div>
    );
}
